const safeStorage = {
    getItem(key) {
        try {
            return localStorage.getItem(key);
        } catch (e) {
            console.error(e);

            return null;
        }
    },

    setItem(key, value) {
        try {
            localStorage.setItem(key, value);
        } catch (e) {
            console.error(e);
        }
    },

    removeItem(key) {
        try {
            localStorage.removeItem(key);
        } catch (e) {
            console.error(e);
        }
    }
};

export {
    safeStorage
};
